import { useCallback, useMemo } from "react";
import URI from "urijs";
import useSendEventActionTelemetry from "components/events/events/hooks/useSendEventActionTelemetry";
import Routes from "routing/Routes";
import Store from "logic/local-storage/Store";
import generateId from "logic/generateId";
import { REPLAY_SESSION_ID_PARAM } from "components/events/Constants";
import useLocation from "routing/useLocation";
import useHistory from "routing/useHistory";
const useReplayBulkAction = (replayableEvents) => {
  const sendEventActionTelemetry = useSendEventActionTelemetry();
  const eventIds = useMemo(() => replayableEvents.map((event) => event.id), [replayableEvents]);
  const { pathname, search } = useLocation();
  const history = useHistory();
  return useCallback(() => {
    const sessionId = generateId();
    const url = new URI(Routes.ALERTS.BULK_REPLAY_SEARCH).search({
      [REPLAY_SESSION_ID_PARAM]: sessionId
    }).toString();
    sendEventActionTelemetry("REPLAY_SEARCH", true, { events_length: eventIds.length });
    Store.sessionSet(sessionId, { initialEventIds: eventIds, returnUrl: `${pathname}${search}` });
    history.push(url);
  }, [eventIds, history, pathname, search, sendEventActionTelemetry]);
};
export default useReplayBulkAction;
